!<!--  -->
<template>
  <div class>
    <div class style="padding:30px; background: #FFFFFF;
box-shadow: rgb(107 105 105 / 21%) 0px 0px 20px 0px;
    border-radius: 10px;">
      <!-- 修改密码 -->
      <div class>
        <div class>
          <span
            style="font-size: 24px;font-family: PingFang SC;font-weight: bold;color: #343434;"
          >用户管理</span>
        </div>
        <div class>
          <span
            style="font-size: 18px;font-family: PingFang SC;font-weight: 500;color: #343434;line-height: 51px;"
          >修改密码</span>
          <div class="block" style="margin-bottom:20px">
            <span
              style="font-size: 16px; font-family: PingFang SC; font-weight: 400; color: #9A9A9A;float:left;line-height:40px;margin-right:40px;color:#999999"
            >旧密码</span>
            <el-input placeholder="请输入旧密码" clearable show-password v-model="oldPwd" style="float:left;width:400px"></el-input>
          </div>
          <div class="block" style="margin-bottom:20px">
            <span
              style="font-size: 16px; font-family: PingFang SC; font-weight: 400; color: #9A9A9A;float:left;line-height:40px;margin-right:40px;color:#999999"
            >新密码</span>
            <el-input placeholder="请输入新密码" clearable show-password  v-model="newPwd" style="float:left;width:400px"></el-input>
          </div>
          <div class="block" style="margin-bottom:20px">
            <span
              style="font-size: 16px; font-family: PingFang SC; font-weight: 400; color: #9A9A9A;float:left;line-height:40px;margin-right:24px;color:#999999"
            >确认密码</span>
            <el-input placeholder="请输入确认密码" clearable show-password  v-model="newPwdConfirm" style="float:left;width:400px"></el-input>
          </div>
        </div>

        <el-button
          @click="submit"
          style="width: 150px; height: 40px; background: #FF4D01; border-radius: 5px;color:#fff"
        >确定修改</el-button>
      </div>
      <!-- 修改手机 -->
      <div class>
        <div class style="height:30px">
          <!-- <span style="font-size: 24px;font-family: PingFang SC;font-weight: bold;color: #343434;">用户管理</span> -->
        </div>
        <div class>
          <span
            style="font-size: 18px;font-family: PingFang SC;font-weight: 500;color: #343434;line-height: 51px;"
          >更改手机号</span>
          <div class="block" style="margin-bottom:20px">
            <span
              style="font-size: 16px; font-family: PingFang SC; font-weight: 400; color: #9A9A9A;float:left;line-height:40px;margin-right:40px;color:#999999"
            >当前手机号</span>
            <span
              style="font-size: 16px; font-family: PingFang SC; font-weight: 500; color: #333333; line-height: 40px;"
            >{{phoneNo}}</span>
            <div style="display: inline-block;margin-left: 100px;" v-if="phoneNo">
              <el-button type="primary" @click="handleWxConnect">
                {{!$store.state.Authorization.isBindedWebOpenId ? "绑定微信" : "解绑微信" }}
              </el-button>
              <el-tooltip content="绑定微信且关注货代拼公众号，微信上第一时间接收询盘消息推送通知" placement="right">
                <el-icon class="el-icon-question" style="color: #666666"></el-icon>
              </el-tooltip>
            </div>
          </div>
          <div class="block" style="margin-bottom:20px">
            <span
              style="font-size: 16px; font-family: PingFang SC; font-weight: 400; color: #9A9A9A;float:left;line-height:40px;margin-right:56px;color:#999999"
            >新手机号</span>
            <el-input placeholder="新手机号" v-model="newPhone" style="float:left;width:400px">
              <template slot="prepend">+86</template>
            </el-input>
          </div>
          <div class="block" style="margin-bottom:20px">
            <span
              style="font-size: 16px; font-family: PingFang SC; font-weight: 400; color: #9A9A9A;float:left;line-height:40px;margin-right:70px;color:#999999"
            >验证码</span>
            <el-input placeholder="验证码" v-model="code" style="float:left;width:400px">
              <el-button @click="sendCode" slot="append">{{countDown > 0 ? countDown : '获取验证码'}}</el-button>
            </el-input>
          </div>
        </div>
        <el-button @click="submitPhone"
          style="width: 150px; height: 40px; background: #FF4D01; border-radius: 5px;color:#fff"
        >确定修改</el-button>
      </div>
      <!-- 修改邮箱 -->
      <div class>
        <div class style="height:30px">
          <!-- <span style="font-size: 24px;font-family: PingFang SC;font-weight: bold;color: #343434;">用户管理</span> -->
        </div>
        <div class>
          <span
            style="font-size: 18px;font-family: PingFang SC;font-weight: 500;color: #343434;line-height: 51px;"
          >{{ email ? '修改邮箱号' : '绑定邮箱号' }}</span>
          <div class="block" style="margin-bottom:20px" v-if="email">
            <span
              style="font-size: 16px; font-family: PingFang SC; font-weight: 400; color: #9A9A9A;float:left;line-height:40px;margin-right:70px;color:#999999"
            >旧邮箱</span>
            <span
              style="font-size: 16px; font-family: PingFang SC; font-weight: 500; color: #333333; line-height: 40px;"
            >{{email}}</span>
          </div>
          <div class="block" style="margin-bottom:20px">
            <span
              style="font-size: 16px; font-family: PingFang SC; font-weight: 400; color: #9A9A9A;float:left;line-height:40px;margin-right:70px;color:#999999;width: 48px;"
            >{{ email ? '新邮箱' : '邮箱' }}</span>
            <el-input placeholder="请输入邮箱" v-model="newEmail" style="float:left;width:400px"></el-input>
          </div>
          <div class="block" style="margin-bottom:20px">
            <span
              style="font-size: 16px; font-family: PingFang SC; font-weight: 400; color: #9A9A9A;float:left;line-height:40px;margin-right:70px;color:#999999"
            >验证码</span>
            <el-input placeholder="验证码" v-model="newEmailCode" style="float:left;width:400px">
              <el-button @click="sendCodeByEmail" slot="append" v-loading="buttonLoading">{{emailCountdown > 0 ? emailCountdown : '获取验证码'}}</el-button>
            </el-input>
          </div>
        </div>
        <el-button @click="emailSubmit"
                   style="width: 150px; height: 40px; background: #FF4D01; border-radius: 5px;color:#fff"
        >{{ email ? '确定修改' : '确定' }}</el-button>
      </div>
      <el-dialog
        title="扫码绑定微信"
        :visible.sync="wxCodeVisible"
        width="30%"
        center
      >
        <span>
          <div class="tips"></div>
          <div class="login-wx-code">
            <div id="wx_login_container"></div>
          </div>
        </span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="wxCodeVisible = false">取 消</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import qs from "qs";
import {getUserLoginInfo} from "../../../assets/js/baseDataRuquest";

export default {
  components: {},
  data() {
    //这里存放数据
    return {
      // password: "123",
      // username: "test_0006",
    //   密码修改
      newPwd: "",
      newPwdConfirm: "",
      oldPwd: "",
      userInfo:{},
      countDown: 0,
    //   修改手机号
      phone: "",
      newPhone: "",
      code: "",

      phoneNo:"",
      // 修改邮箱
      email: '',
      newEmail: '',
      newEmailCode: '',
      emailCountdown: 0,
      buttonLoading: false,
      wxCodeVisible: false
    };
  },
  computed: {},
  watch:{
			countDown(val){
				if(val <= 0){
					clearInterval(this.timer)

				}
			}
		},
  //方法集合
  methods: {
        // 修改手机号
      submitPhone() {
				if (!this.code || !this.newPhone){
                    this.$message.info("验证码或手机号不能为空'");
                    return
                }
				if (!(/^1[3456789]\d{9}$/.test(this.newPhone))) {

					 this.$message.info("手机号码有误，请重填");
                    return
                }
                let user = localStorage.getItem("Authorization_lineSupplier");
                    user = JSON.parse(user);

				this.$http.post('/user/updateUserPhoneNo',  qs.stringify({
					'phoneNo': this.newPhone,
					'smsCode': this.code

				}), {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",

            },

				}).then(res => {
					if (res.data.code !== 200){
                        this.$message.info( res.data.message);
                        return
                    }

            this.userInfo.phoneNo = res.data.data.phoneNo
            localStorage.setItem("Authorization_lineSupplier",JSON.stringify(this.userInfo))
            this.phoneNo = res.data.data.phoneNo


					this.$message.info("修改手机号成功");

					this.newPhone = ''
					this.code = ''

					// setTimeout(function() {
					// 	uni.navigateBack({
					// 		delta: 1
					// 	});
					// }, 1200);
				}).catch(res => {
					console.log(res)
				})
			},


    // 发送验证码
    sendCode() {

      if (this.countDown != 0) {
        this.$message.info("请" + this.countDown + "秒后再发送");

        return;
      }

      if (!/^1[3456789]\d{9}$/.test(this.newPhone)) {
        this.$message.info("手机号码有误，请重填");
        return false;
      }

      // if (this.phone == this.newPhone) return uni.showToast({
      // 	title: '手机号不能一样！',
      // 	icon: 'none'
      // });

      // if (!this.phone || !this.newPhone) return uni.showToast({
      // 	title: '请输手机号码',
      // 	icon: "none"
      // });
      if (!this.newPhone) {
        this.$message.info("请输手机号码");
        return;
      }
       let user = localStorage.getItem("Authorization_lineSupplier");
      user = JSON.parse(user);
      this.$http
        .get(
          "/user/requestRegisterSmsCode/" + this.newPhone,

          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
              token: user.token,
            },
          }
        )
        .then((res) => {
          if (res.data.code !== 200){
            this.$message.info(res.data.message);
            return
          }

         this.$message.info("发送成功！");

          if (this.countDown > 0) {
            return;
          }

          clearInterval(this.timer);

          this.countDown = 3;
          this.timer = setInterval(() => {
            this.countDown--;
            console.log(this.countDown)
          }, 1000);
        })
        .catch((res) => {
          console.log(res);
        });
    },

    //   密码修改
    submit() {
      if (!this.newPwd || !this.newPwdConfirm || !this.oldPwd) {
        this.$message.info("密码不能为空！");
      }

      if (this.newPwd != this.newPwdConfirm) {
        this.$message.info("确认密码不一样！");
      }
      let user = localStorage.getItem("Authorization_lineSupplier");
      user = JSON.parse(user);

      this.axios
        .post(
          "/user/updatePwd",
          qs.stringify({ newPwd: this.newPwd, oldPwd: this.oldPwd }),
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",

            },
          }
        )
        .then((res) => {
            console.log(res);

          if (res.data.code != 200) {
            this.$message.info(res.data.message);
            return;
          }

          this.$message.info("修改" + res.data.message + "");
          this.oldPwd = ''
          this.newPwd = ''
          this.newPwdConfirm = ''

          // 清除token

          // setTimeout(function() {
          // 	uni.clearStorageSync()

          // 	uni.reLaunch({
          // 		url: '../user/mydata',

          // 		// complete() {
          // 		// 	this.loadin = false
          // 		// 	uni.showToast({
          // 		// 		title: '退出成功！'
          // 		// 	});
          // 		// }
          // 	})
          // }, 1000);
        })
        .catch((res) => {
          console.log(res);
        });
    },
    validEmail(email) {
      if (!email) return false
      const reg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/
      return reg.test(email)
    },
    sendCodeByEmail() {
      if (!this.validEmail(this.newEmail)) {
        return this.$message.warning('请输入正确的邮箱地址')
      }
      if (this.emailCountdown > 0) {
        this.$message.info("请" + this.emailCountdown + "秒后再发送");
        return
      }
      this.buttonLoading = true
      const type = this.$store.state.Authorization.authenticationInfoDTO.type
      this.axios.get(`/api/user/sendCodeByEmail/${this.newEmail}/${type}`).then(res => {
        if (res.data.code === 200) {
          this.$message.success('验证码发送成功')
          this.buttonLoading = false
          this.emailCountdown = 60
          this.timer = setInterval(() => {
            this.emailCountdown--
            if (this.emailCountdown < 0) {
              clearInterval(this.timer)
            }
          }, 1000)
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    emailSubmit() {
      if (!this.validEmail(this.newEmail)) {
        return this.$message.warning('请输入正确的邮箱地址')
      }
      if (!this.newEmailCode) {
        return this.$message.warning('请输入验证码')
      }
      this.axios.get(`/api/user/updateUserEmailByEmailCode?email=${this.newEmail}&emailCode=${this.newEmailCode}`)
        .then(res => {
          if (res.data.code === 200) {
            this.$message.success('邮箱更新成功')
            this.email = this.newEmail
            this.userInfo.email = this.newEmail
            localStorage.setItem("Authorization_lineSupplier",JSON.stringify(this.userInfo))
            this.newEmail = ''
            this.newEmailCode = ''
          } else {
            this.$message.error(res.data.message)
          }
        })
    },
    handleWxConnect() {
      if (!this.$store.state.Authorization.isBindedWebOpenId) {
        this.bindWx()
      } else {
        this.unbindWx()
      }
    },
    bindWx() {
      this.wxCodeVisible = true
      this.axios.get("/wechatCarrier/qrCodeCreateCarrierBind").then((res) => {
        if (res.data.code === 200) {
          this.$nextTick(() => {
            let address = res.data.data.qrCode;
            // let address = 'http://qa2.huodaipin.com.cn/api/wechatCarrier/bindNotify'
            var obj = new WxLogin({
              self_redirect: false,
              id: "wx_login_container",
              appid: res.data.data.appId,
              scope: "snsapi_login",
              redirect_uri: address,
              state: res.data.data.qrKey,
              style: "black",
              // href: "data:text/css;base64,LmltcG93ZXJCb3ggLnFyY29kZXsKICAgICB3aWR0aDogMTAwJTsgICAgICAgICAgIAp9", //https://某个域名下的css文件
              href: "data:text/css;base64,LmltcG93ZXJCb3ggLnFyY29kZXsNCiAgICAgd2lkdGg6IDI2MHB4OyAgICAgICAgICAgDQp9DQouaW1wb3dlckJveCAuc3RhdHVzIHsNCiAgICBwYWRkaW5nOiA3cHggMTRweDsNCiAgICB0ZXh0LWFsaWduOiBjZW50ZXI7DQp9",
            });
          });
        } else {
          this.$message({ message: res.data.message, type: "error" });
        }
      });
    },
    unbindWx() {
      this.$confirm('确定解绑该微信吗？', '提示', {type: 'warning'})
        .then(() => {
          this.axios.get('/wechatCarrier/unbindWechatQrCode')
            .then(res => {
              if (res.data.code !== 200) {
                this.$message.error(res.data.message);
              } else {
                this.$message.success(res.data.message)
                this.getUserInfo()
              }
            })
        })
    },
    getUserInfo() {
      getUserLoginInfo()
        .then(res => {
          let user
          if (res.code === 200) {
            localStorage.setItem("Authorization_lineSupplier",JSON.stringify(res.data))
            this.$store.state.Authorization = res.data
            user = res.data
          } else {
            user = localStorage.getItem("Authorization_lineSupplier");
            user = JSON.parse(user);
          }
          this.userInfo = user
          this.phoneNo = user.phoneNo
          this.email = user.email
        })
    }

  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.getUserInfo()
  },
};
</script>
<style  scoped>
/* //@import url(); 引入公共css类 */
.block {
  float: left;
  width: 100%;
}
.login-wx-code {
  text-align: center;
  margin-top: -35px;
}
</style>



// WEBPACK FOOTER //
// src/components/PersonalCenter/accountManage/UserManage.vue